// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Alert = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Alert = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Alert = _exports.Alert = function Alert(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M9.99935 1.66699C5.39685 1.66699 1.66602 5.39783 1.66602 10.0003C1.66602 14.6028 5.39685 18.3337 9.99935 18.3337C14.6018 18.3337 18.3327 14.6028 18.3327 10.0003C18.3327 5.39783 14.6018 1.66699 9.99935 1.66699ZM9.37435 6.25033C9.37435 5.90533 9.65435 5.62533 9.99935 5.62533C10.3443 5.62533 10.6243 5.90533 10.6243 6.25033V10.0595C10.6243 10.4045 10.3443 10.6845 9.99935 10.6845C9.65435 10.6845 9.37435 10.4045 9.37435 10.0595V6.25033ZM10.016 13.7503C9.55603 13.7503 9.17843 13.377 9.17843 12.917C9.17843 12.457 9.54769 12.0837 10.0077 12.0837H10.016C10.4769 12.0837 10.8494 12.457 10.8494 12.917C10.8494 13.377 10.476 13.7503 10.016 13.7503Z",
      fill: "currentColor"
    }));
  };
});
